import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class GridColumns {
  caption: string;
  dataField: string;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
};
export class District {
  DistrictID: number;
  DistrictName: string;
  DistrictCode: string;
  StateID:number;
  StateName :string;
  CountryName :string;
  CreatedLoginID:number;
  UpdatedLoginID:number;
} 
let gridColumns: GridColumns[] = [
{
  "caption": 'Country Name',
  "dataField": "CountryName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}, 
{
  "caption": 'State Name',
  "dataField": "StateName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}, 
{
  "caption": 'District Name',
  "dataField": "DistrictName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Code',
  "dataField": "DistrictCode",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}
];
@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  constructor(
    private dataService: DataAccessService) {
  }
  public DistrictData: District;
  public getAllDistrict() {
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'GetBasicDistrictForList?DistrictID=0'; // setting method name from API controller.
    return this.dataService.getAll<District[]>()
  }
  public getDistrictByID(DistrictID) {
    debugger
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'GetBasicDistrictForList?DistrictID=' + DistrictID +''; // setting method name from API controller.
    return this.dataService.getAll<District[]>()
  } 
  public getDistrictByStateID(StateID) {
    debugger
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'GetBasicDistrictByStateID?StateID=' + StateID +''; // setting method name from API controller.
    return this.dataService.getAll<District[]>()
  }

  public save(data) {
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'PostInsertBasicDistrict'; // setting method name from API controller.
    return this.dataService.add<District[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'PostBasicDistrict'; // setting method name from API controller.
    return this.dataService.add<District[]>(data)
  }
  public delete(data) {
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'PostDeleteBasicDistrict'; // setting method name from API controller.
    return this.dataService.delete<District[]>(data)
  }
  getGridColumnsData() {
    return District[0];
  }
  getGridColumns() {
    return gridColumns;
  }
}
